import type { FC, ReactNode, MouseEventHandler } from 'react';
import { Card, CardHeader, CardContent } from '@mui/material';

interface InfoCardProps {
	title: string;
	children: ReactNode;
	onClick?: MouseEventHandler<HTMLDivElement>;
}

const InfoCard: FC<InfoCardProps> = ({ title, children }) => (
	<Card variant="outlined">
		<CardHeader title={title} sx={{ color: 'grey.600' }} />
		<CardContent>{children}</CardContent>
	</Card>
);

export default InfoCard;
